import { Pie } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

// Register Chart.js components
ChartJS.register(ArcElement, Tooltip, Legend);

export default function PieChart({ sectionTotals }) {
  // Ensure costs are rounded to two decimal places
  const formattedSectionTotals = sectionTotals.map((section) => ({
    title: section.title,
    cost: parseFloat(section.cost || 0).toFixed(2),
  }));

  // Calculate grandTotal as the sum of sectionTotals.cost
  const grandTotal = formattedSectionTotals
    .reduce((sum, section) => sum + parseFloat(section.cost || 0), 0)
    .toFixed(2);

  const data = {
    labels: formattedSectionTotals.map((s) => s.title),
    datasets: [
      {
        label: "Section Costs",
        data: formattedSectionTotals.map((s) => parseFloat(s.cost)),
        backgroundColor: [
          "#FF6384",
          "#36A2EB",
          "#FFCE56",
          "#4BC0C0",
          "#9966FF",
          "#FF9F40",
        ],
        borderColor: [
          "#FF6384",
          "#36A2EB",
          "#FFCE56",
          "#4BC0C0",
          "#9966FF",
          "#FF9F40",
        ],
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
        labels: {
          font: {
            size: 12,
          },
        },
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            let label = context.label || "";
            if (label) label += ": ";
            label +=
              "$" +
              parseFloat(context.parsed || 0).toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              });
            return label;
          },
        },
      },
    },
  };

  return (
    <div className="flex flex-col items-center">
      <h4 className="text-lg font-semibold text-gray-800 mb-2">
        Total Estimated Cost: $
        {parseFloat(grandTotal).toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}
      </h4>
      <div className="w-full max-w-md">
        <Pie data={data} options={options} />
      </div>
    </div>
  );
}
